export enum SwipeActions {
  left = 0,
  right = 1,
  up = 2,
  bottom = 3
}
